import Chat from "./Chat/index.js";
import Block from "./Block/index.js";
import Client from "./Client/index.js";
import Merchant from "./Merchant/index.js";
import SmsService from "./SmsService/index.js";
import Category from "./Category/index.js";
import Tag from "./Tag/index.js";
import File from "./File/index.js";
import BrandMerchant from "./BrandMerchant/index.js";
import Dashboard from "./Dashboard/index.js";
import Design from "./Design/index.js";
import Page from "./Page/index.js";
import Promotion from "./Promotion/index.js";
import Transaction from "./Transaction/index.js";
import MerchantPaymentGateway from "./MerchantPaymentGateway/index.js";
import GasBrandMerchant from "./GasBrandMerchant/index.js";
import Trunc from "./Trunc/index.js";
import QrCard from "./QrCard/index.js";
import Total from "./Total/index.js";
import Coupon from "./Coupon/index.js";
import AsyncJob from "./AsyncJob/index.js";
import EmailService from "./EmailService/index.js";
import ErrorPage from "./ErrorPage.js";
import PushNotificationService from "./PushNotificationService/index.js";

export default {
  Chat,
  Block,
  Client,
  Merchant,
  SmsService,
  Category,
  Tag,
  File,
  BrandMerchant,
  Dashboard,
  Design,
  Page,
  Promotion,
  Transaction,
  MerchantPaymentGateway,
  GasBrandMerchant,
  Trunc,
  QrCard,
  Total,
  Coupon,
  AsyncJob,
  EmailService,
  ErrorPage,
  PushNotificationService,
};
